import axios from 'axios';

export const getToken = async () => {
    try {
        const response = await axios.post('/admin/realms/tenant-realm/protocol/openid-connect/token');
        // const response = await axios.post(
        //     `http://localhost:8081/realms/hia-realm/protocol/openid-connect/token`, 
        //     `grant_type=client_credentials&client_id=showroom&client_secret=ezKUNAFwDY49j6oxKISHO7zYHWIzgIIi`, 
        //     {
        //         headers: {
        //             'Content-Type': 'application/x-www-form-urlencoded',
        //         },
        //     }
        // );
        const token = response.data.access_token;
        return token;
    } catch (error) {
        console.error('Error fetching the token', error);
        throw new Error('Error fetching the token');
    }
}
